import script from "./page-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./page-settings.vue?vue&type=script&setup=true&lang=js"

import "./page-settings.vue?vue&type=style&index=0&id=74cdf34d&lang=scss"

const __exports__ = script;

export default __exports__